import { memo, useState } from 'react';
import { getIsDuplicateRecording } from '@goldcast/player-config/src/utils/clipUtils';
import PlayerTimelineButton from './PlayerTimelineButton';
import ConfirmationDialog from '@/components/organisms/ConfirmationDialog';
import useDialog from '@/components/organisms/useDialog';
import { resetFullClipChanges } from '@/libs/fullRecordingEdit';
import { useClipsContext } from '@/context/ClipsContext/ClipsContext';
import useEditorRestrictions from '@/hooks/useEditorRestrictions';
import { useRemotionPlayerPause } from '@/App/remotion/MainPlayer/ClipPlayerV2WithNewTimeline/hooks/useRemotionPlayerPause';
import EventBus from '@/libs/eventBus/eventBus';
import { CustomEvents } from '@/libs/eventBus/constants';

function RevertChange() {
  const [revertingChanges, setRevertingChanges] = useState(false);

  const { pause } = useRemotionPlayerPause();
  const { clipId, clipData } = useClipsContext();
  const { isBlocked } = useEditorRestrictions();
  const {
    isOpen: isResetChangesDialogOpen,
    openDialog: openResetChangesDialog,
    closeDialog: closeResetChangesDialog
  } = useDialog();

  async function resetFullRecordingChanges() {
    pause();
    setRevertingChanges(true);
    resetFullClipChanges(clipId);

    EventBus.dispatch(CustomEvents.ClearAiChat, { silent: true });

    closeResetChangesDialog();
  }

  // Reverting full-recording changes doesn't apply to duplicate recordings, so hide the control.
  if (getIsDuplicateRecording(clipData)) {
    return null;
  }

  return (
    <>
      <PlayerTimelineButton
        tooltipTitle={revertingChanges ? 'Reverting...' : 'Discard all edits'}
        buttonId="new-timeline-revert-changes-button"
        onClick={openResetChangesDialog}
        isLoading={revertingChanges}
        isDisabled={isBlocked('clip-undo-redo')}
        iconName={'IconRestore'}
      />
      <ConfirmationDialog
        isOpen={isResetChangesDialogOpen}
        onClose={closeResetChangesDialog}
        onConfirm={resetFullRecordingChanges}
        title="Revert Changes"
        content="Are you sure you want to revert to the original version of this video? Your current changes will be lost."
        confirmLabel="Revert Changes"
      />
    </>
  );
}

export default memo(RevertChange);
